<template>

  <div class="index-garden">


    <div class="clearfix index-title-block">
      <div class="pull-left index-title">
        <i class="fa fa-book"></i>
        虚拟课堂
      </div>
      <div class="pull-right index-title-more">
							<span class="nb-a" @click.stop.prevent="$router.push('/'+topic.location+'/class/informationdesign')">
								更多
								<i class="fa fa-caret-square-o-right color-main"></i> </span>
      </div>
    </div>
    <div class="index-content-block">
      <div class="img-block" :style="'background-image:url('+article.poster.url+')'"></div>
      <div v-html="article.content"></div>


    </div>

    <div class="gif-content-block">
      <a class="gif-a" href="javascript:void(0)">
        <img alt="1" class="gif-item" src="../../../../../common/assets/img/gif/1.gif"/>
      </a>
      <a class="gif-a" href="javascript:void(0)">
        <img alt="1" class="gif-item" src="../../../../../common/assets/img/gif/2.gif"/>
      </a>
      <a class="gif-a" href="javascript:void(0)">
        <img alt="1" class="gif-item" src="../../../../../common/assets/img/gif/3.gif"/>
      </a>

    </div>

  </div>

</template>


<script>

import Swiper from "swiper";

import Carousel from "../../../../../common/model/carousel/Carousel";
import Person from "../../../../../common/model/person/Person";
import Article from "../../../../../common/model/article/Article";
import Pager from "../../../../../common/model/base/Pager";
import {startWith} from "../../../../../common/filter/str";

export default {

  props: {},
  data() {
    return {
      personPager: new Pager(Person),
      swiper: null,
      article: new Article()
    };
  },
  computed: {
    topic() {
      return this.$route.meta.topic;
    }
  },
  watch: {},
  methods: {

    refresh() {

      let that = this;
      this.personPager.httpFastPage(function () {

        setTimeout(function () {

          that.swiper = new Swiper('.leader-swiper-container', {
            autoplay: 3000,
            speed: 1000,
            // Optional parameters
            direction: 'horizontal',
            loop: true,

            paginationClickable: true,

            slidesPerView: 4,
            spaceBetween: 10
          });
        }, 200);


      })


    }
  },
  mounted() {
    this.refresh();

    this.article.id = 3;
    this.article.httpDetail();
  }
};
</script>


<style lang="less" rel="stylesheet/less">

.index-garden {


  .img-block {
    height: 165px;
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    margin-bottom: 15px;

    background-image: url("../../../../../common/assets/img/course/study-garden.png");
  }

  .index-content-block {

    @media (min-width: 1200px) {
      min-height: 307px;
      line-height: 29px;
    }
    @media (min-width: 992px) and (max-width: 1200px) {
      min-height: 346px;
    }


  }

  .gif-content-block {
    margin-top: 10px;
    display: flex;

    .gif-a {
      flex: 1;
      margin: 1px;

      .gif-item {
        width: 100%;
      }
    }


  }


}

</style>



// WEBPACK FOOTER //
// IndexGarden.vue?6ffc35c4